module.exports = __webpack_public_path__ + "img/asan1.1652cc92.png";